
const statusOptions = [
    {key: 1, label: 'To do'},
    {key: 2, label: 'In progress'},
    {key: 3, label: 'Pending validation'},
    {key: 4, label: 'Validated'},
];

export default statusOptions;
